import styled from "styled-components";

interface Props{
  $hasError?: Boolean;
}

const Info = styled.div<Props>`
  align-self: stretch;
  color: ${(props) => props.$hasError ? "#d32f2f" : "1e1e1e"};
  font-family: Inter, Oxygen, Roboto, sans-serif;
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
  position: relative;
  text-align: left;
`;

export default Info;
